// Per-page SEO titles & descriptions in ES / EN / PT.
// Optimized with geo intent (Argentina + LATAM) and product keywords (Site CTMS, eSource).

export const SEO_META = {
  ES: {
    demo: {
      title: "Solicitar demo | Brainmart MED CT",
      description:
        "Agenda una demo de 30 minutos de Brainmart MED CT, el software para la gestión integral de ensayos clínicos en centros de investigación. Site CTMS, eSource, HCE y eISF.",
    },
    home: {
      title: "Brainmart MED CT | Software para ensayos clínicos",
      description:
        "Software Site CTMS y eSource para centros de investigación clínica en Argentina, Colombia, Puerto Rico y México. Digitaliza HCE, farmacia, laboratorio, eISF y administración con trazabilidad lista para auditorías (FDA 21 CFR Part 11, GCP, ALCOA++).",
    },
    modules: {
      title: "Módulos | Brainmart MED CT — Site CTMS, HCE, farmacia, eISF",
      description:
        "Conocé los módulos de Brainmart: Site CTMS, HCE protocolarizada, farmacia, laboratorio, eISF, agenda, administración y Oversight. Una sola plataforma para todo el centro de investigación clínica.",
    },
    faq: {
      title: "Preguntas frecuentes | Brainmart MED CT — Site CTMS y eSource",
      description:
        "Respuestas a las preguntas frecuentes sobre Brainmart: qué es un Site CTMS, cumplimiento regulatorio, modelo DDA, monitoreo remoto, seguridad y beneficios para el centro de investigación.",
    },
    cases: {
      title: "Casos y Papers | Brainmart MED CT — Resultados en investigación clínica",
      description:
        "Casos de éxito y papers científicos sobre digitalización de centros de investigación clínica con Brainmart Site CTMS en Latinoamérica.",
    },
    glossary: {
      title: "Glosario de investigación clínica | Brainmart MED CT",
      description:
        "Glosario A-Z de términos de investigación clínica: CTMS, eSource, HCE, eISF, GCP, ALCOA++, monitoreo, auditoría y más. Recurso de Brainmart MED CT.",
    },
    blog: {
      title: "Blog | Brainmart MED CT — Investigación clínica y Site CTMS",
      description:
        "Artículos, guías y novedades sobre gestión de centros de investigación clínica, eSource, cumplimiento regulatorio y tecnología CTMS en Latinoamérica.",
    },
    changelog: {
      title: "Novedades del producto | Brainmart MED CT",
      description:
        "Historial de versiones y mejoras de Brainmart MED CT: nuevas funciones, optimizaciones y correcciones de la plataforma Site CTMS & eSource.",
    },
    veeva: {
      title: "Brainmart vs Veeva | Comparativa Site CTMS para Latinoamérica",
      description:
        "Comparativa entre Brainmart y Veeva para centros de investigación clínica en Latinoamérica: enfoque site-first, eSource y modelo DDA sin costo para el site.",
    },
  },
  EN: {
    demo: {
      title: "Request a demo | Brainmart MED CT",
      description:
        "Book a 30-minute demo of Brainmart MED CT, comprehensive clinical trial management software for research sites. Site CTMS, eSource, EHR and eISF.",
    },
    home: {
      title: "Brainmart MED CT | Clinical Trial Management Software",
      description:
        "Site CTMS and eSource software for clinical research centers in Argentina, Colombia, Puerto Rico and Mexico. Digitalize EHR, pharmacy, lab, eISF and administration with audit-ready traceability (FDA 21 CFR Part 11, GCP, ALCOA++).",
    },
    modules: {
      title: "Modules | Brainmart MED CT — Site CTMS, EHR, Pharmacy, eISF",
      description:
        "Discover Brainmart modules: Site CTMS, protocolarized EHR, pharmacy, laboratory, eISF, agenda, administration and Oversight. One platform for the entire clinical research center.",
    },
    faq: {
      title: "FAQ | Brainmart MED CT — Site CTMS & eSource",
      description:
        "Answers to frequently asked questions about Brainmart: what a Site CTMS is, regulatory compliance, the DDA model, remote monitoring, security and benefits for the research center.",
    },
    cases: {
      title: "Cases & Papers | Brainmart MED CT — Clinical Research Results",
      description:
        "Success cases and scientific papers on the digitalization of clinical research centers with Brainmart Site CTMS in Latin America.",
    },
    glossary: {
      title: "Clinical Research Glossary | Brainmart MED CT",
      description:
        "A-Z glossary of clinical research terms: CTMS, eSource, EHR, eISF, GCP, ALCOA++, monitoring, audit and more. A Brainmart MED CT resource.",
    },
    blog: {
      title: "Blog | Brainmart MED CT — Clinical Research & Site CTMS",
      description:
        "Articles, guides and news on clinical research site management, eSource, regulatory compliance and CTMS technology in Latin America.",
    },
    changelog: {
      title: "Product Updates | Brainmart MED CT",
      description:
        "Version history and improvements of Brainmart MED CT: new features, optimizations and fixes for the Site CTMS & eSource platform.",
    },
    veeva: {
      title: "Brainmart vs Veeva | Site CTMS Comparison for Latin America",
      description:
        "Comparison between Brainmart and Veeva for clinical research centers in Latin America: site-first approach, eSource and DDA model with no cost for the site.",
    },
  },
  PT: {
    demo: {
      title: "Solicitar demo | Brainmart MED CT",
      description:
        "Agende uma demo de 30 minutos do Brainmart MED CT, o software para a gestão integral de ensaios clínicos em centros de pesquisa. Site CTMS, eSource, prontuário e eISF.",
    },
    home: {
      title: "Brainmart MED CT | Software para ensaios clínicos",
      description:
        "Software Site CTMS e eSource para centros de pesquisa clínica na Argentina, Colômbia, Porto Rico e México. Digitalize PEP, farmácia, laboratório, eISF e administração com rastreabilidade pronta para auditorias (FDA 21 CFR Part 11, GCP, ALCOA++).",
    },
    modules: {
      title: "Módulos | Brainmart MED CT — Site CTMS, PEP, farmácia, eISF",
      description:
        "Conheça os módulos da Brainmart: Site CTMS, PEP protocolizada, farmácia, laboratório, eISF, agenda, administração e Oversight. Uma única plataforma para todo o centro de pesquisa clínica.",
    },
    faq: {
      title: "Perguntas frequentes | Brainmart MED CT — Site CTMS e eSource",
      description:
        "Respostas às perguntas frequentes sobre a Brainmart: o que é um Site CTMS, conformidade regulatória, modelo DDA, monitoramento remoto, segurança e benefícios para o centro de pesquisa.",
    },
    cases: {
      title: "Casos e Papers | Brainmart MED CT — Resultados em pesquisa clínica",
      description:
        "Casos de sucesso e papers científicos sobre a digitalização de centros de pesquisa clínica com a Brainmart Site CTMS na América Latina.",
    },
    glossary: {
      title: "Glossário de pesquisa clínica | Brainmart MED CT",
      description:
        "Glossário A-Z de termos de pesquisa clínica: CTMS, eSource, PEP, eISF, GCP, ALCOA++, monitoramento, auditoria e mais. Um recurso da Brainmart MED CT.",
    },
    blog: {
      title: "Blog | Brainmart MED CT — Pesquisa clínica e Site CTMS",
      description:
        "Artigos, guias e novidades sobre gestão de centros de pesquisa clínica, eSource, conformidade regulatória e tecnologia CTMS na América Latina.",
    },
    changelog: {
      title: "Novidades do produto | Brainmart MED CT",
      description:
        "Histórico de versões e melhorias da Brainmart MED CT: novos recursos, otimizações e correções da plataforma Site CTMS & eSource.",
    },
    veeva: {
      title: "Brainmart vs Veeva | Comparativo Site CTMS para a América Latina",
      description:
        "Comparativo entre Brainmart e Veeva para centros de pesquisa clínica na América Latina: abordagem site-first, eSource e modelo DDA sem custo para o site.",
    },
  },
};

export const getMeta = (lang, page) => (SEO_META[lang] || SEO_META.ES)[page];
